import { NavContextType } from "src/components/navigation/NavContext"
import { AppShellLayout } from "src/components/ui/AppShellLayout";
import { Icons } from "src/components/ui/Icons"

import { NotFound } from "src/screens/global/NotFound";
import { TalentProfile } from "src/screens/talent/TalentProfile";
import { TalentAdminHome } from "src/screens/talent/TalentAdminHome";
import { Portal } from "src/components/navigation/Portal";
import { TalentAdminBookings } from "src/screens/talent/bookings/TalentAdminBookings";
import { TalentAdminBookingLayout } from "src/components/talent/bookings/TalentAdminBookingLayout";
import { TalentAdminBooking } from "src/screens/talent/bookings/TalentAdminBooking";
import { TalentAdminBookingBreadCrumb } from "src/components/talent/bookings/TalentAdminBookingBreadcrumb";
import { TalentAdminBookingGuidelines } from "src/screens/talent/bookings/guidelines/TalentAdminBookingGuidelines";
import { RouteDrawer } from "src/components/navigation/RouteDrawer";
import { TalentAdminBookingOverlay } from "src/screens/talent/bookings/TalentAdminBookingOverlay";
import { TalentAdminBookingGuidelinesOverlay } from "src/screens/talent/bookings/guidelines/TalentAdminBookingGuidelinesOverlay";
import { CalendarPortal } from "src/components/calendar/CalendarPortal";
import { TalentAdminBookingsCalendar } from "src/screens/talent/bookings/TalentAdminBookingsCalendar";
import { TalentAdminDocuments } from "src/screens/talent/documents/TalentAdminDocuments";
import { TalentAdminBlackouts } from "src/screens/talent/blackouts/TalentAdminBlackouts";
import { SuperAdminThreadLayout } from "src/components/superadmin/threads/SuperAdminThreadLayout";
import { TalentAdminThreads } from "src/screens/talent/threads/TalentAdminThreads";
import { SuperAdminThread } from "src/screens/superadmin/threads/SuperAdminThread";
import { SuperAdminThreadBreadCrumb } from "src/components/superadmin/threads/SuperAdminThreadBreadcrumb";
import { SuperAdminThreadOverlay } from "src/screens/superadmin/threads/SuperAdminThreadOverlay";
import { TalentAdminGuidelines } from "src/screens/talent/guidelines/TalentAdminGuidelines";

export const TalentAdminRoutes = ():NavContextType => ({
    routes: [
        {
            path: '/',
            element: <AppShellLayout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <TalentAdminHome />, breadcrumb: 'Home' },
                { path: "profile", element: <TalentProfile />, breadcrumb: 'Talent Profile' },
                {
                    path: "inbox",
                    element: <Portal />,
                    breadcrumb: 'Inbox',
                    children: [
                        { index: true, element: <TalentAdminThreads /> },
                        {
                            path: ":threadId",
                            element: <SuperAdminThreadLayout />,
                            children: [
                                { index: true, element: <SuperAdminThread />, breadcrumb: SuperAdminThreadBreadCrumb }
                            ]
                        }
                    ]
                },
                {
                    path: "calendar",
                    element: <CalendarPortal />,
                    breadcrumb: 'Calendar',
                    children: [
                        { index: true, element: <TalentAdminBookingsCalendar /> },
                    ]
                },
                {
                    path: "bookings",
                    element: <Portal />,
                    breadcrumb: "Bookings",
                    children: [
                        { index: true, element: <TalentAdminBookings /> },
                        {
                            path: ":bookingId",
                            element: <TalentAdminBookingLayout />,
                            children: [
                                { index: true, element: <TalentAdminBooking />, breadcrumb: TalentAdminBookingBreadCrumb },
                                { path: "guidelines", element: <TalentAdminBookingGuidelines />, breadcrumb: 'Guidelines' }
                            ]
                        }
                    ]
                },
                { path: "blackouts", element: <TalentAdminBlackouts />, breadcrumb: 'Blackout Dates' },
                { path: "documents", element: <TalentAdminDocuments />, breadcrumb: 'Documents' },
                { path: "guidelines", element: <TalentAdminGuidelines />, breadcrumb: 'Guidelines' },
                { path: "*", element: <NotFound />, breadcrumb: 'Not Found' }
            ]
        }
    ],
    overlays: [
        {
            path: "/inbox/:threadId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminThreadLayout />,
                    children: [
                        { index: true, element: <SuperAdminThreadOverlay /> }
                    ]
                }
            ],
        },
        {
            path: "/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <TalentAdminBookingLayout />,
                    children: [
                        { index: true, element: <TalentAdminBookingOverlay /> },
                        { path: "guidelines", element: <TalentAdminBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        },
    ],
    menu: [ 
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/blackouts',
            label: 'Blackout Dates',
            icon: Icons.blackout
        },
        {
            to: '/documents',
            label: 'Documents',
            icon: Icons.files
        },
        {
            to: '/guidelines',
            label: 'Guidelines',
            icon: Icons.guideline
        },
        {
            to: '/profile',
            label: 'Profile',
            icon: Icons.user
        }
    ],
    mobile: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/blackouts',
            label: 'Blackout Dates',
            icon: Icons.blackout
        },
        {
            to: '/documents',
            label: 'Documents',
            icon: Icons.files
        },
        {
            to: '/guidelines',
            label: 'Guidelines',
            icon: Icons.guideline
        },
        {
            to: '/profile',
            label: 'Profile',
            icon: Icons.user
        }
    ]
})
